import React from 'react';
import './ProjectDetail.css';

const WarehouseOperationsAnalytics = () => {
  const icons = [
    { src: '/images/excel.png', alt: 'Excel' },
  ];

  return (
    <section className="project-detail-page">
      <div className="detail-content">
        <div className="icon-row">
          {icons.map((icon, index) => (
            <img key={index} src={icon.src} alt={icon.alt} className="icon" />
          ))}
        </div>

        <h1>Warehouse Operations Analytics Dashboard (Excel Project)</h1>
        <p className="detail-subtitle">
          Analyzing Daily Pick Throughput, Zone Efficiencies, and Inventory Flow Using Excel
        </p>

        <section className="detail-section">
          <h2>Project Overview</h2>
          <p>
            This project models warehouse picking operations using an anonymized dataset to evaluate daily throughput,
            identify performance patterns, and highlight opportunities for operational efficiency. The analysis replicates real
            distribution-center behavior, including zone-level activity, inventory classification, and shifting pick volumes across
            a 70-day window. I completed the entire analysis in Microsoft Excel.
          </p>
        </section>

        <section className="detail-section">
          <h2>What Problem This Solves</h2>
          <ul>
            <li>Which pick zones drive the most volume</li>
            <li>When efficiency drops during the day or week</li>
            <li>How inventory classification (A/B/C items) affects overall flow</li>
            <li>Which areas require reslotting or workload balancing</li>
            <li>How throughput changes over time</li>
          </ul>
        </section>

        {/* <section className="detail-section">
          <h2>Key KPIs &amp; Definitions</h2>
          <ul>
            <li>Total Daily Pick Volume - aggregate picks across all active storage zones</li>
            <li>High-Velocity Item Ratio - % of A-classified items within the daily workload</li>
            <li>Zone Throughput Heatmap - conditional formatting grid for zone performance</li>
            <li>Zone Efficiency Index - normalized score representing throughput vs. expected baseline</li>
            <li>ABC Classification Ratio - inventory class breakdown per day</li>
            <li>Share of Picks in A vs. B/C/D - shows how much labor stays in the fastest zone</li>
            <li>Trendline Forecast - movement patterns over 70 days</li>
          </ul>
        </section> */}

        <section className="detail-section">
          <h2>Insights Found</h2>
          <ul>
            <li>High-Velocity Zones consistently peaked mid-month, suggesting workload smoothing opportunities.</li>
            <li>Sector B showed increasing variability, indicating replenishment or slotting inefficiencies.</li>
            <li>Fast-Move Zone throughput spiked disproportionately, showing potential labor imbalance.</li>
            <li>Overall pick volume increased toward month-end, common in retail replenishment cycles.</li>
          </ul>
          <p>These insights help managers prioritize labor, slotting, and replenishment adjustments.</p>
        </section>

        {/* <section className="detail-section">
          <img
            src="/images/dashOverview.png"
            alt="Dashboard overview placeholder"
            className="detail-image"
          />
          <h2>Dashboard Overview</h2>
          <p>
            The overview tracks daily throughput, efficiency, and classification mix in one place so managers can adjust
            labor and replenishment before backlogs form.
          </p>
        </section> */}

        <section className="detail-section">
          <img
            src="/images/pick-location-quantity-graph.png"
            alt="Pick locations of picks over time"
            className="detail-image"
          />
          <h2>Pick Locations Over Time</h2>
          <p>
            All pick locations as totals over 70 days show the full spread beyond A/B/C/D and where volume really lands; spikes
            flag zones to re-slot or rebalance so the next picks stay in A.
          </p>
        </section>

        <section className="detail-section">
          <img
            src="/images/pivottable-ratios.png"
            alt="Pivot chart showing quantity of picks for all locations over time"
            className="detail-image"
          />
          <h2>Pivoted Pick Quantities</h2>
          <p>
            Pivot ratios highlight quantity flow across every location, surfacing bottlenecks and capacity gaps so supervisors can
            keep fast movers in A and reduce travel in slower zones.
          </p>
        </section>

        <section className="detail-section">
          <img
            src="/images/percentA.png"
            alt="Percent of A picks compared to B, C, and D"
            className="detail-image"
          />
          <h2>Percent A vs. B/C/D</h2>
          <p>
            A / (A+B+C+D) measures whether the next-to-be-picked products stay in A, the fastest zone; dips suggest mis-slotting
            or forecast drift.
          </p>
        </section>

        {/* <section className="detail-section">
          <h2>Embedded Comparison View</h2>
          <p>
            This embedded chart placeholder lets you compare how a hosted visualization could look next to the Excel-first
            screenshots.
          </p>
          <div className="embed-container">
            <iframe
              src="https://onedrive.live.com/embed?resid=5B6E64B0D8820C4A%21163&authkey=!AG7Hfqx-PPYUajQ&em=2&wdAllowInteractivity=True&wdDownloadButton=True&wdHideGridlines=True&wdInConfigurator=True"
              title="Embedded Excel visualization placeholder"
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
        </section> */}

        <section className="detail-section">
          <h2>Data Pipeline</h2>
          <p>The flow mirrors the sales dashboard structure for clarity and repeatability:</p>
          <ul>
            <li>Raw picks exported from the WMS into Excel.</li>
            <li>Cleaning and structuring of pick, zone, and item-class fields.</li>
            <li>PivotTables to aggregate by day, zone, and classification.</li>
            <li>KPI calculations (efficiency, A/B/C/D mix, throughput ratios).</li>
            <li>Charts and heatmaps assembled into the final dashboard.</li>
          </ul>
        </section>

        {/* <section className="detail-section">
          <a className="primary-button" href="https://garrettalbracht.work/projects/data-processing">
            View Project
          </a>
        </section> */}
      </div>
    </section>
  );
};

export default WarehouseOperationsAnalytics;